module.exports = __webpack_public_path__ + "static/media/bim.8b7f0701.png";